import type { AxiosError } from "axios";
import { worktimeApi } from "@wkt/api/worktime";
import type { GenericServiceResponseDTO } from "@wkt/api/profileDTO";
import type {
  DocumentsInfoDTO,
  SignRequestValidationDTO,
} from "./documentsDTO";

type SuccessCallback<T = unknown> = (data: T) => void;
type ErrorCallback = (error: AxiosError) => void;

export class DocumentsAPI {
  getDocumentsInfo(
    onSuccess: SuccessCallback<DocumentsInfoDTO>,
    onError: ErrorCallback
  ): void {
    worktimeApi.genericGet("user/documents-info", onSuccess, onError);
  }

  getDocumentById(
    documentId: number,
    onSuccess: SuccessCallback<unknown>,
    onError: ErrorCallback
  ): void {
    worktimeApi.genericGet(`user/getDocumentById/${documentId}`, onSuccess, onError);
  }

  requestSignCode(
    documentId: number,
    onSuccess: SuccessCallback<GenericServiceResponseDTO>,
    onError: ErrorCallback
  ): void {
    worktimeApi.genericGet(`user/requestSignCode/${documentId}`, onSuccess, onError);
  }

  validateSignCode(
    data: SignRequestValidationDTO,
    onSuccess: SuccessCallback<GenericServiceResponseDTO>,
    onError: ErrorCallback
  ): void {
    worktimeApi.genericPost("user/validateSignCode", data, onSuccess, onError);
  }

  uploadDocument(
    file: File,
    itemId: number,
    onSuccess: SuccessCallback<string>,
    onError: ErrorCallback
  ): void {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("encoded-filename", file.name);
    formData.append("item-id", String(itemId));

    worktimeApi.genericPost("user/uploadDocument", formData, onSuccess, onError);
  }

  uploadSignaturePicture(
    documentId: number,
    dataUrl: string,
    onSuccess: SuccessCallback<unknown>,
    onError: ErrorCallback
  ): void {
    worktimeApi.genericPost("user/uploadSignaturePicture", `${documentId}&${dataUrl}`, onSuccess, onError);
  }
}

export const documentsApi = new DocumentsAPI();
export default documentsApi;
